module.exports = __webpack_public_path__ + "static/media/panelImg.af1664ed.jpg";